import { FeatureFlagIDs } from "../../models/config";
import { useFeatureFlagGlobalStore } from "../use-feature-flag-global-store";

interface UseFeatureFlagSimpleProps {
  id: FeatureFlagIDs;
}

export const useFeatureFlagSimple = ({ id }: UseFeatureFlagSimpleProps) => {
  const getFeatureFlag = useFeatureFlagGlobalStore((state) => state.getFeatureFlag);
  const isFeatureFlagEnabled = useFeatureFlagGlobalStore((state) => state.isFeatureFlagEnabled);
  const isLoading = useFeatureFlagGlobalStore((state) => state.isLoading);

  const featureFlag = getFeatureFlag(id);
  const isEnabled = isFeatureFlagEnabled(id);

  return {
    featureFlag,
    isEnabled,
    loading: isLoading,
    error: null, // No error since we're using cached data
  };
};
